import { useDispatch, useSelector } from "react-redux";
import { downloadCommReviewReport } from "../thunks/downloadReport";
import React from "react";
import { StoreType } from "../../../../../core/store/reducers";
import { FetchStateType } from "../../../../models";

export const useCommReviewReportDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.reports.exchbusiness.commReview.downloadReportFetchState
  );
  const dispatch = useDispatch();
  const download = React.useCallback(
    () => dispatch(downloadCommReviewReport()),
    [dispatch]
  );

  return [download, fetchState] as [typeof download, typeof fetchState];
};
